import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const TeacherMessages = () => {
  const routes = all_routes;
  const [activeTab, setActiveTab] = useState("inbox");
  const [selectedMessage, setSelectedMessage] = useState<any>(null);

  const messages = {
    inbox: [
      {
        id: 1,
        from: "John Smith (Parent)",
        subject: "Emma's Math Progress",
        preview:
          "Hello, I wanted to discuss Emma's recent performance in mathematics...",
        time: "2 hours ago",
        read: false,
        type: "parent",
        avatar: "JS",
      },
      {
        id: 2,
        from: "Admin Office",
        subject: "Faculty Meeting Tomorrow",
        preview:
          "Reminder: Faculty meeting scheduled for tomorrow at 3 PM in the conference room...",
        time: "4 hours ago",
        read: true,
        type: "admin",
        avatar: "AO",
      },
      {
        id: 3,
        from: "Maria Garcia (Parent)",
        subject: "Request for Meeting",
        preview:
          "Could we schedule a parent-teacher meeting to discuss Carlos's behavior...",
        time: "1 day ago",
        read: false,
        type: "parent",
        avatar: "MG",
      },
    ],
    sent: [
      {
        id: 4,
        to: "Lisa Johnson (Parent)",
        subject: "Homework Reminder",
        preview:
          "This is a friendly reminder about the pending mathematics assignment...",
        time: "Yesterday",
        type: "parent",
        avatar: "LJ",
      },
    ],
  };

  const getTypeColor = (type: string) => {
    switch (type) {
      case "parent":
        return "primary";
      case "admin":
        return "warning";
      case "student":
        return "info";
      default:
        return "secondary";
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="row mb-4">
            <div className="col">
              <h3 className="page-title mb-2">Messages</h3>
              <p className="text-muted mb-0">
                Communicate with parents, students, and administration
              </p>
            </div>
            <div className="col-auto">
              <button className="btn btn-primary">
                <i className="ti ti-plus me-1"></i>
                New Message
              </button>
            </div>
          </div>

          {/* Message Stats */}
          <div className="row mb-4">
            <div className="col-md-3 col-sm-6">
              <div className="card text-center">
                <div className="card-body">
                  <div className="avatar avatar-md bg-primary-transparent mx-auto mb-2">
                    <i className="ti ti-mail text-primary"></i>
                  </div>
                  <h5 className="text-primary">
                    {messages.inbox.filter((m) => !m.read).length}
                  </h5>
                  <small>Unread</small>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card text-center">
                <div className="card-body">
                  <div className="avatar avatar-md bg-success-transparent mx-auto mb-2">
                    <i className="ti ti-send text-success"></i>
                  </div>
                  <h5 className="text-success">{messages.sent.length}</h5>
                  <small>Sent Today</small>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card text-center">
                <div className="card-body">
                  <div className="avatar avatar-md bg-info-transparent mx-auto mb-2">
                    <i className="ti ti-users text-info"></i>
                  </div>
                  <h5 className="text-info">
                    {messages.inbox.filter((m) => m.type === "parent").length}
                  </h5>
                  <small>From Parents</small>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card text-center">
                <div className="card-body">
                  <div className="avatar avatar-md bg-warning-transparent mx-auto mb-2">
                    <i className="ti ti-building text-warning"></i>
                  </div>
                  <h5 className="text-warning">
                    {messages.inbox.filter((m) => m.type === "admin").length}
                  </h5>
                  <small>From Admin</small>
                </div>
              </div>
            </div>
          </div>

          {/* Messages */}
          <div className="card">
            <div className="card-header">
              <ul className="nav nav-tabs card-header-tabs">
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "inbox" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("inbox")}
                  >
                    <i className="ti ti-inbox me-1"></i>
                    Inbox ({messages.inbox.length})
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "sent" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("sent")}
                  >
                    <i className="ti ti-send me-1"></i>
                    Sent ({messages.sent.length})
                  </button>
                </li>
              </ul>
            </div>
            <div className="card-body p-0">
              {activeTab === "inbox" && (
                <div>
                  {messages.inbox.map((message) => (
                    <div
                      key={message.id}
                      className={`d-flex align-items-center p-3 border-bottom cursor-pointer ${
                        !message.read ? "bg-light" : ""
                      }`}
                      onClick={() => setSelectedMessage(message)}
                    >
                      <div
                        className={`avatar avatar-sm bg-${getTypeColor(
                          message.type
                        )}-transparent me-3`}
                      >
                        <span
                          className={`text-${getTypeColor(
                            message.type
                          )} fw-bold`}
                        >
                          {message.avatar}
                        </span>
                      </div>
                      <div className="flex-fill">
                        <div className="d-flex align-items-center justify-content-between mb-1">
                          <h6
                            className={`mb-0 ${!message.read ? "fw-bold" : ""}`}
                          >
                            {message.from}
                          </h6>
                          <small className="text-muted">{message.time}</small>
                        </div>
                        <p
                          className={`mb-1 ${
                            !message.read ? "fw-semibold" : ""
                          }`}
                        >
                          {message.subject}
                        </p>
                        <p className="text-muted mb-0 small">
                          {message.preview}
                        </p>
                      </div>
                      {!message.read && (
                        <div className="badge bg-primary rounded-pill ms-2">
                          New
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {activeTab === "sent" && (
                <div>
                  {messages.sent.map((message) => (
                    <div
                      key={message.id}
                      className="d-flex align-items-center p-3 border-bottom cursor-pointer"
                      onClick={() => setSelectedMessage(message)}
                    >
                      <div
                        className={`avatar avatar-sm bg-${getTypeColor(
                          message.type
                        )}-transparent me-3`}
                      >
                        <span
                          className={`text-${getTypeColor(
                            message.type
                          )} fw-bold`}
                        >
                          {message.avatar}
                        </span>
                      </div>
                      <div className="flex-fill">
                        <div className="d-flex align-items-center justify-content-between mb-1">
                          <h6 className="mb-0">To: {message.to}</h6>
                          <small className="text-muted">{message.time}</small>
                        </div>
                        <p className="mb-1">{message.subject}</p>
                        <p className="text-muted mb-0 small">
                          {message.preview}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {((activeTab === "inbox" && messages.inbox.length === 0) ||
                (activeTab === "sent" && messages.sent.length === 0)) && (
                <div className="text-center py-5">
                  <div className="avatar avatar-xl bg-light-transparent mx-auto mb-3">
                    <i className="ti ti-mail fs-2"></i>
                  </div>
                  <h5>No messages</h5>
                  <p className="text-muted">No messages in this folder.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Message Detail Modal */}
      {selectedMessage && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{selectedMessage.subject}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setSelectedMessage(null)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="d-flex align-items-center mb-3">
                  <div
                    className={`avatar avatar-sm bg-${getTypeColor(
                      selectedMessage.type
                    )}-transparent me-3`}
                  >
                    <span
                      className={`text-${getTypeColor(
                        selectedMessage.type
                      )} fw-bold`}
                    >
                      {selectedMessage.avatar}
                    </span>
                  </div>
                  <div>
                    <h6 className="mb-0">
                      {selectedMessage.from || `To: ${selectedMessage.to}`}
                    </h6>
                    <small className="text-muted">{selectedMessage.time}</small>
                  </div>
                </div>
                <div className="border-top pt-3">
                  <p>{selectedMessage.preview}</p>
                  <p>
                    This is the full message content. In a real application,
                    this would contain the complete message text with proper
                    formatting and any attachments.
                  </p>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary">
                  <i className="ti ti-arrow-back-up me-1"></i>
                  Reply
                </button>
                <button className="btn btn-outline-secondary">
                  <i className="ti ti-share me-1"></i>
                  Forward
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setSelectedMessage(null)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TeacherMessages;
